// SSV2300_CONFI_OPEDA_WS
export const FETCH_SSV2300_CONFI_OPEDA_WS_BY_ID = "fetchSsv2300ConfiOpedaWsById";
export const FETCH_PAGINATED_SSV2300_CONFI_OPEDA_WSS = "fetchPaginatedSsv2300ConfiOpedaWss";
export const UPDATE_SSV2300_CONFI_OPEDA_WS = "updateSsv2300ConfiOpedaWs";
export const CREATE_SSV2300_CONFI_OPEDA_WS = "createSsv2300ConfiOpedaWs";
export const DELETE_SSV2300_CONFI_OPEDA_WS = "deleteSsv2300ConfiOpedaWs";
export const RESET_SSV2300_CONFI_OPEDA_WS_FILTERS = "resetSsv2300ConfiOpedaWsFilters";
export const RESET_SSV2300_CONFI_OPEDA_WS = "resetSsv2300ConfiOpedaWs";
export const RESET_SSV2300_CONFI_OPEDA_WSS_LIST = "resetSsv2300ConfiOpedaWssList";

// SSV2307_USURO_CADTR_CRTOR
export const FETCH_SSV2307_USURO_CADTR_CRTOR_BY_ID = "fetchSsv2307UsuroCadtrCrtorById";
export const FETCH_PAGINATED_SSV2307_USURO_CADTR_CRTORS = "fetchPaginatedSsv2307UsuroCadtrCrtors";
export const UPDATE_SSV2307_USURO_CADTR_CRTOR = "updateSsv2307UsuroCadtrCrtor";
export const CREATE_SSV2307_USURO_CADTR_CRTOR = "createSsv2307UsuroCadtrCrtor";
export const DELETE_SSV2307_USURO_CADTR_CRTOR = "deleteSsv2307UsuroCadtrCrtor";
export const RESET_SSV2307_USURO_CADTR_CRTOR_FILTERS = "resetSsv2307UsuroCadtrCrtorFilters";
export const RESET_SSV2307_USURO_CADTR_CRTOR = "resetSsv2307UsuroCadtrCrtor";
export const RESET_SSV2307_USURO_CADTR_CRTORS_LIST = "resetSsv2307UsuroCadtrCrtorsList";

// SSV2308_EXCEC_RADAR_COTAC
export const FETCH_SSV2308_EXCEC_RADAR_COTAC_BY_ID = "fetchSsv2308ExcecRadarCotacById";
export const FETCH_PAGINATED_SSV2308_EXCEC_RADAR_COTACS = "fetchPaginatedSsv2308ExcecRadarCotacs";
export const UPDATE_SSV2308_EXCEC_RADAR_COTAC = "updateSsv2308ExcecRadarCotac";
export const CREATE_SSV2308_EXCEC_RADAR_COTAC = "createSsv2308ExcecRadarCotac";
export const DELETE_SSV2308_EXCEC_RADAR_COTAC = "deleteSsv2308ExcecRadarCotac";
export const RESET_SSV2308_EXCEC_RADAR_COTAC_FILTERS = "resetSsv2308ExcecRadarCotacFilters";
export const RESET_SSV2308_EXCEC_RADAR_COTAC = "resetSsv2308ExcecRadarCotac";
export const RESET_SSV2308_EXCEC_RADAR_COTACS_LIST = "resetSsv2308ExcecRadarCotacsList";

// SSV2314_CADTR_FLAG_WS
export const FETCH_SSV2314_CADTR_FLAG_WS_BY_ID = "fetchSsv2314CadtrFlagWsById";
export const FETCH_PAGINATED_SSV2314_CADTR_FLAG_WSS = "fetchPaginatedSsv2314CadtrFlagWss";
export const UPDATE_SSV2314_CADTR_FLAG_WS = "updateSsv2314CadtrFlagWs";
export const CREATE_SSV2314_CADTR_FLAG_WS = "createSsv2314CadtrFlagWs";
export const DELETE_SSV2314_CADTR_FLAG_WS = "deleteSsv2314CadtrFlagWs";
export const RESET_SSV2314_CADTR_FLAG_WS_FILTERS = "resetSsv2314CadtrFlagWsFilters";
export const RESET_SSV2314_CADTR_FLAG_WS = "resetSsv2314CadtrFlagWs";
export const RESET_SSV2314_CADTR_FLAG_WSS_LIST = "resetSsv2314CadtrFlagWssList";

// SSV2340_CONFI_CRTOR_WS
export const FETCH_SSV2340_CONFI_CRTOR_WS_BY_ID = "fetchSsv2340ConfiCrtorWsById";
export const FETCH_PAGINATED_SSV2340_CONFI_CRTOR_WSS = "fetchPaginatedSsv2340ConfiCrtorWss";
export const UPDATE_SSV2340_CONFI_CRTOR_WS = "updateSsv2340ConfiCrtorWs";
export const CREATE_SSV2340_CONFI_CRTOR_WS = "createSsv2340ConfiCrtorWs";
export const DELETE_SSV2340_CONFI_CRTOR_WS = "deleteSsv2340ConfiCrtorWs";
export const RESET_SSV2340_CONFI_CRTOR_WS_FILTERS = "resetSsv2340ConfiCrtorWsFilters";
export const RESET_SSV2340_CONFI_CRTOR_WS = "resetSsv2340ConfiCrtorWs";
export const RESET_SSV2340_CONFI_CRTOR_WSS_LIST = "resetSsv2340ConfiCrtorWssList";

// SSV2341_CONFI_CRTOR_FLAG_WS
export const FETCH_SSV2341_CONFI_CRTOR_FLAG_WS_BY_ID = "fetchSsv2341ConfiCrtorFlagWsById";
export const FETCH_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS = "fetchPaginatedSsv2341ConfiCrtorFlagWss";
export const UPDATE_SSV2341_CONFI_CRTOR_FLAG_WS = "updateSsv2341ConfiCrtorFlagWs";
export const CREATE_SSV2341_CONFI_CRTOR_FLAG_WS = "createSsv2341ConfiCrtorFlagWs";
export const DELETE_SSV2341_CONFI_CRTOR_FLAG_WS = "deleteSsv2341ConfiCrtorFlagWs";
export const RESET_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS = "resetSsv2341ConfiCrtorFlagWsFilters";
export const RESET_SSV2341_CONFI_CRTOR_FLAG_WS = "resetSsv2341ConfiCrtorFlagWs";
export const RESET_SSV2341_CONFI_CRTOR_FLAG_WSS_LIST = "resetSsv2341ConfiCrtorFlagWssList";

// SSV2303_CONFI_AUTO_FNCRA
export const FETCH_SSV2303_CONFI_AUTO_FNCRA_BY_ID = "fetchSsv2303ConfiAutoFncraById";
export const FETCH_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS = "fetchPaginatedSsv2303ConfiAutoFncras";
export const UPDATE_SSV2303_CONFI_AUTO_FNCRA = "updateSsv2303ConfiAutoFncra";
export const CREATE_SSV2303_CONFI_AUTO_FNCRA = "createSsv2303ConfiAutoFncra";
export const DELETE_SSV2303_CONFI_AUTO_FNCRA = "deleteSsv2303ConfiAutoFncra";
export const RESET_SSV2303_CONFI_AUTO_FNCRA_FILTERS = "resetSsv2303ConfiAutoFncraFilters";
export const RESET_SSV2303_CONFI_AUTO_FNCRA = "resetSsv2303ConfiAutoFncra";
export const RESET_SSV2303_CONFI_AUTO_FNCRAS_LIST = "resetSsv2303ConfiAutoFncrasList";